/* eslint-disable */
export const SystemRole = {
    ADMIN: "ADMIN",
    VIEWER: "VIEWER",
    LAB_USER: "LAB_USER",
    FIRST_LEVEL_EDITOR: "FIRST_LEVEL_EDITOR",
    SECOND_LEVEL_EDITOR: "SECOND_LEVEL_EDITOR",
    THIRD_LEVEL_EDITOR: "THIRD_LEVEL_EDITOR",
    FOURTH_LEVEL_EDITOR: "FOURTH_LEVEL_EDITOR",

    isAdmin() {
        return localStorage.getItem("role") === this.ADMIN;
    },

    isUser() {
        return localStorage.getItem("role") === this.USER;
    },

    getUserRole() {
        return localStorage.getItem("role");
    },

};
